/** Controle "Ordenar por" compartilhado pelas telas de Pacientes e Reuniões Clínicas. */
export const BASE_SORT_OPTIONS = [
  { value: "name_asc", label: "Nome — A a Z" },
  { value: "name_desc", label: "Nome — Z a A" },
  { value: "admission_asc", label: "Data de internação — mais antiga primeiro" },
  { value: "admission_desc", label: "Data de internação — mais recente primeiro" },
  { value: "discharge_asc", label: "Data prevista de alta — mais próxima primeiro" },
  { value: "discharge_desc", label: "Data prevista de alta — mais distante primeiro" },
  { value: "counselor", label: "Conselheiro — ordem alfabética" },
  { value: "psychologist", label: "Psicólogo(a) — ordem alfabética" },
  { value: "psychiatrist", label: "Psiquiatra — ordem alfabética" },
];

export const MEETING_SORT_OPTIONS = [
  { value: "priority", label: "Prioridade para discussão" },
  { value: "without_desc", label: "Maior tempo sem discussão" },
  { value: "without_asc", label: "Menor tempo sem discussão" },
  { value: "last_discussion_asc", label: "Última discussão — mais antiga primeiro" },
  { value: "last_discussion_desc", label: "Última discussão — mais recente primeiro" },
];

export const DEFAULT_SORT = "name_asc";

export const SortSelect = ({ value, onChange, includeMeeting = false, testId = "sort-select", className = "" }) => (
  <label className={`flex w-full min-w-0 flex-wrap items-center gap-2 text-[13.5px] text-ink-600 sm:w-auto ${className}`}>
    Ordenar por
    <select
      data-testid={testId}
      aria-label="Ordenar por"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-11 w-full min-w-0 max-w-full rounded-xl border border-border bg-white px-3.5 text-[14px] text-ink-800 focus:border-sage-600 focus:outline-none focus:ring-2 focus:ring-sage-600/15 sm:w-auto"
    >
      {[...BASE_SORT_OPTIONS, ...(includeMeeting ? MEETING_SORT_OPTIONS : [])].map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </label>
);
